import { loadStripe } from '@stripe/stripe-js';
import axios from '@utils/webRequests';
import { createContext, useContext, useEffect, useState } from 'react'

const PaymentsApiContext = createContext();
const PaymentsApiProvider = ({ children }) => {
  const [paymentsPromise, setPaymentsPromise] = useState(null)
  const [isCustomerCreated, setIsCustomerCreated] = useState(false)

  const getPaymentsPromise = () => {
    let promise
    if (!paymentsPromise) {
      promise = loadStripe(process.env.REACT_APP_PAYMENTS_PUBLISHABLE_KEY)
      setPaymentsPromise(promise)
    }
    return promise || paymentsPromise
  }

  const findOrCreateCustomer = () => {
    if (!isCustomerCreated) {
      return axios.post('/api/billing/customers')
        .then(() => setIsCustomerCreated(true))
    } else {
      return Promise.resolve()
    }
  }

  const createSubscription = (plan) => {
    return axios.post('/api/billing/subscriptions', { plan })
  }

  const createSetupIntent = (plan) => {
    return axios.post('/api/billing/setup_intents')
  }

  return (
    <PaymentsApiContext.Provider value={{
      getPaymentsPromise,
      paymentsPromise,

      findOrCreateCustomer,
      isCustomerCreated,

      createSubscription,
      createSetupIntent,
      }}>
      {children}
    </PaymentsApiContext.Provider>
  )
}

const usePaymentsApiContext = () => useContext(PaymentsApiContext)

export default usePaymentsApiContext

export { PaymentsApiContext, PaymentsApiProvider, usePaymentsApiContext }
